import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@gray/domain/http/api.service';

/** What a task may point at; at most one of the two, checked by the API against the student. */
export interface ICoachTaskContentRef {
  videoId?: number;
  liveStreamId?: number;
  periodId?: number | null;
}

/** Tasks the coach assigned to a student; the API scopes every call to the acting coach. */
@Injectable({providedIn: 'root'})
export class CoachTaskService {

  private apiPrefix = '/coach/tasks';

  constructor(
    private api: ApiService,
  ) {
  }

  getTasks(studentId: number, queryString = ''): Observable<any> {
    return this.api.get(`${this.apiPrefix}/students/${studentId}`, queryString);
  }

  /**
   * A plain task, or one pointing at content the student should watch. The period says which
   * library the API checks that content against — a student's library differs per period.
   */
  createTask(studentId: number, content: string, contentRef?: ICoachTaskContentRef): Observable<any> {
    return this.api.post(`${this.apiPrefix}/students/${studentId}`, {content, ...(contentRef ?? {})});
  }

  updateTask(taskId: number, content: string): Observable<any> {
    return this.api.patch(`${this.apiPrefix}/${taskId}`, {content});
  }

  toggleTask(taskId: number, isCompleted: boolean): Observable<any> {
    return this.api.patch(`${this.apiPrefix}/${taskId}/completion`, {isCompleted});
  }

  deleteTask(taskId: number): Observable<any> {
    return this.api.delete(`${this.apiPrefix}/${taskId}`);
  }
}
